<template>
	<div class="flex w-full flex-col lg:flex-row">
		<div class="lg:w-1/2 lg:pr-10">
			<h2 class="w-full">What is a car subscription?</h2>
			<div class="space-y-5 text-lg text-gray-575">
				<p>
					A car subscription service is an affordable alternative to
					buying, financing or leasing a car.
				</p>
				<p>
					Rather than paying a lump sum to own outright or using
					finance to access a depreciating asset, we take all the key
					costs of owning and running a car, and roll it up into a
					simple, convenient weekly subscription^.
				</p>
				<p>
					The car is yours for as long you are subscribed to it. You
					can stop or swap with just two weeks’ notice.
				</p>
			</div>
			<div class="mt-8">
				<TermsAndConditions :is-full-width="false">
					^ Excludes tolls, fuel and infringements.
					<CarbarLink
						:href="'/terms-and-conditions/car-subscription'"
						target="_blank"
						text="Terms and conditions"
						class="text-xsm"
					/>
					apply.
				</TermsAndConditions>
			</div>
			<CarbarImage
				image="img/car-subscription/img-what_is_a_car_subscription.webp"
				alt-text="What is a car subscription"
			/>
		</div>
		<div class="flex flex-col gap-8 lg:w-1/2 lg:pl-10">
			<div v-for="(list, key) in Lists" :key="key">
				<h3 class="font-body font-medium">{{ list.head }}</h3>
				<div class="text-lg">{{ list.content }}</div>
				<div v-if="list.href" class="mt-8">
					<CarbarLink :href="list.href">
						<CarbarButton
							:is-full-width="false"
							:is-outline="true"
							:is-mixed="true"
						>
							{{ list.link }}
						</CarbarButton>
					</CarbarLink>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import CarbarImage from '@/components/CarbarImage.vue'
import CarbarLink from '@/components/links/CarbarLink.vue'
import CarbarButton from '@/components/buttons/CarbarButton.vue'
import TermsAndConditions from '@/components/fineprint/TermsAndConditions.vue'

const props = defineProps({
	icon: {
		type: String,
		default: 'img/common/ico-arrow_down.svg',
		required: false,
	},
})

const Lists = [
	{
		head: 'A flexible alternative to car leasing',
		content:
			'Car leases can be an affordable way for businesses and their employees to access vehicles, but they aren’t the most flexible.',
		link: 'Difference between subscription and leasing',
		href: '/compare-car-subscriptions-vs-leasing',
	},
	{
		head: 'Car subscription vs buying outright',
		content:
			'Car ownership is a dream of many Australians, however it’s not the only way to enjoy the freedom of your own personal vehicle.',
		link: 'Car ownership vs car subscription',
		href: 'https://www.carbar.com.au/blog/car-subscriptions-vs-buying/',
	},
	{
		head: 'Hidden costs of buying a car',
		content:
			'It’s a mistake even seasoned car buyers make – they spot a great deal at the showroom or online and rush to snap it up.',
		link: 'Is car subscription worth it?',
		href: 'https://www.carbar.com.au/blog/what-are-the-hidden-costs-of-buying-a-car/',
	},
]
</script>
